var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailStarLine = function SvgMailStarLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 8.6h-1.2V5.143l-4.757 4.26L3.2 5.13v7.07h6v1.2H2.6a.6.6 0 0 1-.6-.6V3.2a.6.6 0 0 1 .6-.6h10.8a.6.6 0 0 1 .6.6zM3.507 3.8l4.53 3.997L12.5 3.8zM12.5 13.85l-1.587.834.303-1.767-1.284-1.252 1.774-.258L12.5 9.8l.794 1.608 1.774.258-1.284 1.251.303 1.768z"
  })));
};
export default SvgMailStarLine;